import React, { useState, useRef, useEffect, useCallback } from "react"
import Image from "../components/image"
import sliderData from "../data/slider.json"
import { useSwipeable } from "react-swipeable"
import VisibilitySensor from "react-visibility-sensor"
import { useWindowSize } from "../hooks/useWindowSize"

export default function Slider({ id, slides }) {
  const windowSize = useWindowSize()

  let images, title
  if (id && !slides) {
    images = sliderData.find(obj => {
      return obj.id === id
    }).images
    title = sliderData.find(obj => {
      return obj.id === id
    }).title
  } else {
    images = slides
  }

  const sliderHeader = useRef()
  const [offset, setOffset] = useState(0)
  const [slideNumber, setSlideNumber] = useState(1)
  const [slidewidth, setSlideWidth] = useState(365)
  const slidemargin = 20
  const [autoPlayStatus, setAutoPlayStatus] = useState(false)
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => clickRight(),
    onSwipedRight: () => clickLeft(),
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  })

  const moveLeft = useCallback(() => {
    if (slideNumber !== 1) {
      setOffset(offset + slidewidth + slidemargin)
      setSlideNumber(prevSlideNumber => prevSlideNumber - 1)
    }
  }, [slideNumber, offset, setOffset, slidewidth])

  const moveRight = useCallback(() => {
    if (slideNumber !== images.length) {
      setOffset(offset - slidewidth - slidemargin)
      setSlideNumber(prevSlideNumber => prevSlideNumber + 1)
    } else {
      setSlideNumber(1)
      setSlideNumber(1)
      setOffset(0)
    }
  }, [slideNumber, images.length, offset, slidewidth])

  useEffect(() => {
    if (windowSize.width > 1023) {
      setSlideWidth(323)
    } else if (windowSize.width > 376) {
      setSlideWidth(349)
    } else {
      setSlideWidth(280)
    }
    setOffset(0)
    setSlideNumber(1)
  }, [windowSize])

  // Autoplay the slideshow if the prop is set to true, stop autoplay when the user is interacting with the slideshow
  useEffect(() => {
    if (autoPlayStatus === true) {
      const interval = setInterval(moveRight, 5000)
      return () => clearInterval(interval)
    }
  }, [offset, autoPlayStatus, slideNumber, moveRight, moveLeft])

  function clickLeft() {
    setAutoPlayStatus(false)
    moveLeft()
  }

  function clickRight() {
    setAutoPlayStatus(false)
    moveRight()
  }

  return (
    <VisibilitySensor
      partialVisibility={true}
      onChange={isVisible => {
        if (isVisible) {
          setAutoPlayStatus(true)
        }
      }}
    >
      <section id={`slider-${id}`} className="slider">
        <header ref={sliderHeader}>
          {title ? <h4>{title}</h4> : null}
          <nav>
            <button
              className={
                slideNumber === 1
                  ? "slider__button slider__button--disabled icon--arrow-left"
                  : "slider__button icon--arrow-left"
              }
              onClick={() => clickLeft()}
              aria-label="Advance slideshow left"
              aria-controls={`slider-${id}`}
              type="button"
            ></button>
            <button
              className="slider__button icon--arrow-right"
              onClick={() => clickRight()}
              aria-label="Advance slideshow right"
              aria-controls={`slider-${id}`}
              type="button"
            ></button>
          </nav>
        </header>
        <div className="slider__container" {...swipeHandlers}>
          <ul
            className="slider__slides"
            style={{
              width: images.length * slidewidth + images.length * slidemargin,
              transform: `translateX(${offset}px)`,
            }}
          >
            {images.map((image, index) => (
              <li
                key={index}
                style={{
                  width: slidewidth,
                }}
              >
                <Image
                  path={image.imagePath}
                  alt={image.alt ? image.alt : image.title}
                />
                {image.title ? (
                  <p className="caption title--xs">
                    {image.title}
                    {image.name && ` ${image.name}`}
                  </p>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </VisibilitySensor>
  )
}
